import { REFERENCE_LINKS } from '../../../constants';

import type { ButtonSize, ButtonType } from '../../../core';

export const buttonTypes: { value: ButtonType; label: string }[] = [
  { value: 'primary', label: 'Primary' },
  { value: 'secondary', label: 'Secondary' },
  { value: 'standout', label: 'Standout' },
  { value: 'ghost', label: 'Ghost' },
  { value: 'subtle', label: 'Subtle' },
  { value: 'default', label: 'Default' },
  { value: 'destructive', label: 'Destructive' },
  { value: 'destructive-filled', label: 'Destructive (Filled)' },
];

export const buttonSizes: { value: ButtonSize; label: string }[] = [
  { value: 'M', label: 'Medium (M)' },
  { value: 'S', label: 'Small (S)' },
  { value: 'XS', label: 'Extra small (XS)' },
];

export const buttonContents = [
  { value: 'label', label: 'Label and icon' },
  { value: 'icon-only', label: 'Icon only' },
];

export const buttonStates = [
  { value: 'default', label: 'Default' },
  { value: 'disabled', label: 'Disabled' },
];

// The five states of the Figma variant set 1322:91574, in its order. Hover, Active and Focus
// cannot be held on a live button, so the states tables draw them as previews (StatesTable).
export type PreviewState = 'default' | 'hover' | 'active' | 'focus' | 'disabled';

export const previewStates: { value: PreviewState; label: string }[] = [
  { value: 'default', label: 'Default' },
  { value: 'hover', label: 'Hover' },
  { value: 'active', label: 'Active' },
  { value: 'focus', label: 'Focus' },
  { value: 'disabled', label: 'Disabled' },
];

// The types the Builder uses, as the Builder specifications frame lists them (Plain is now Ghost).
export const builderButtonTypes: ButtonType[] = [
  'primary',
  'default',
  'subtle',
  'ghost',
  'destructive',
];

export const dataExternalLinkGroups = [
  {
    id: 1,
    title: 'Government accessibility resources',
    cards: [
      {
        title: 'The Section 508 accessibility program',
        subtitle: '[section508.gov]',
        linkUrl: REFERENCE_LINKS.section508Program,
      },
      {
        title: 'Accessibility for Teams guide',
        subtitle: '[digital.gov]',
        linkUrl: REFERENCE_LINKS.digitalGovAccessibilityForTeams,
      },
      {
        title: 'Find your Section 508 Coordinator',
        subtitle: '[section508.gov]',
        linkUrl: REFERENCE_LINKS.section508ProgramManagerListing,
      },
      {
        title: 'Section 508 ICT Testing Baseline',
        subtitle: '[ictbaseline.access-board.gov]',
        linkUrl: REFERENCE_LINKS.ictTestingBaseline,
      },
      {
        title: 'Learn about writing in plain language',
        subtitle: '[digital.gov]',
        linkUrl: REFERENCE_LINKS.digitalGovPlainLanguageGuide,
      },
      {
        title: '18F’s accessibility guide',
        subtitle: '[guides.18f.org]',
        linkUrl: REFERENCE_LINKS.eighteenFAccessibilityGuide,
      },
      {
        title: 'Accessibility Requirements Tool (ART) for contracting',
        subtitle: '[section508.gov]',
        linkUrl: REFERENCE_LINKS.section508AccessibilityRequirementsTool,
      },
      {
        title: 'Understanding universal design',
        subtitle: '[section508.gov]',
        linkUrl: REFERENCE_LINKS.section508UniversalDesign,
      },
    ],
  },
];
